import React, {  Component } from 'react';

class HelpDesk extends Component {
    render() {
		return (
			<div>
				<h1 className="pageTitle">CONTACT US</h1>
				<h3>Technical Questions</h3>
				<p>
					CustomerNet Help Desk <a className="tel" href="tel:+1-800-242-1333">1-800-242-1333</a><br />
					or email <a target="_blank" href="mailto:customernet@geappliances.com">customernet@geappliances.com</a>
				</p>
				<h3>Product Questions</h3>
				<p>
					GE Answer Center <a className="tel" href="tel:+1-800-626-2000">1-800-626-2000</a>
				</p>
				<h3>Parts Questions</h3>
				<p>
					GE Parts <a className="tel" href="tel:+1-800-851-8777">1-800-851-8777</a><br />
					Parts Wholesalers <a className="tel" href="tel:+1-800-851-6200">1-800-851-6200</a>
				</p>
				<h3>Appliance Service</h3>
				<p>
					Service <a className="tel" href="tel:+1-800-432-2737">1-800-GE-CARES</a> (432-2737)
				</p>
	      	</div>
        );
    }
}

export default HelpDesk;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/HelpDesk/index.js